import React from "react";
import { Col, Row } from "antd";
import Discussion from "./ViewProfileDiscussion";
import { SideBar } from "../../../common/leftsidebar";
import { useSelector } from "react-redux";
import { PROFILE } from "../../../Store/Features/ProfileSlice";
import ScrollToTop from "../../../common/cards/ScrollToTop";

const ViewProfileTimeLineDetails = ({ current }) => {
  const ID = useSelector(PROFILE);
  return (
    <Row justify="center" className="rowPadding" gutter={[20, 0]}>
      <SideBar current={current} eventHistory />
      <ScrollToTop />
      <Col
        xs={{ span: 24, order: 3 }}
        sm={{ span: 24, order: 3 }}
        md={{ span: 24, order: 3 }}
        lg={{ span: 14, order: 2 }}>
        {ID?._id ? <Discussion current={current} /> : null}
      </Col>
    </Row>
  );
};

export default ViewProfileTimeLineDetails;
